import { useMemo } from 'react';

import type { NavItem, NavSection } from './SidebarNav';
import { appNavItemIdPrefix } from './useSidebarItems';

export function isInternalHomePath(pathname: string): boolean {
  return pathname === '/' || pathname.startsWith('/portal/');
}

export function shouldSidebarRedirectFromPath({
  pathname,
  isStudioWorkspace,
  isClient,
}: {
  pathname: string;
  isStudioWorkspace: boolean;
  isClient: boolean;
}): boolean {
  if (pathname === '/no-apps') {
    return true;
  }

  if (isStudioWorkspace && !isClient) {
    return isInternalHomePath(pathname);
  }

  return pathname === '/';
}

export function getFirstAccessibleNavItemRedirectPath(
  navItem: NavItem,
): string {
  if (navItem.isExternalLink) {
    return `/apps?id=${navItem.htmlId.replace(appNavItemIdPrefix, '')}`;
  }

  return navItem.path;
}

export function useFirstAccessibleNavItem(
  mainSidebarSections: Array<NavSection>,
  isClient: boolean,
): NavItem | undefined {
  return useMemo(
    () =>
      (isClient
        ? mainSidebarSections.at(1)
        : mainSidebarSections?.at(0)
      )?.navItems.find((item) => item.canAccess && !item.isHidden),
    [mainSidebarSections, isClient],
  );
}
